<template>
  <div id="userTpl">
    <bio-top-bar></bio-top-bar>
    <div style="background-color:#f5f5f5;">
      <div class="container">
        <div class="bread">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>{{this.$store.state.user_location}}</el-breadcrumb-item>
            <el-breadcrumb-item
              v-if="$store.state.user_location2!=null"
            >{{this.$store.state.user_location2}}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div>
          <div class="clearfix">
            <div class="my_fl">
              <div class="box_left">
                <div class="box_list" v-for="(item , index ) in nav" :key="index">
                  <div class="box_title" @click="changeTitle(index ,isleftList == index)">
                    {{item.title}}
                    <span
                      class="box_icon"
                      :class="isleftList == index ? 'box_icon1' : ''"
                    >
                      <i class="fas fa-chevron-up"></i>
                    </span>

                    <div :class="isleftList == index ? 'box_border' : ''"></div>
                  </div>
                  <el-collapse-transition>
                    <div class="box_show" v-show="isleftList == index">
                      <ul>
                        <router-link
                          :class="isLi == items.path + '/' + isleftList ? 'boxli': '' "
                          v-for="(items,index) in item.arr"
                          :key="index"
                          :to="items.path + '/' + isleftList "
                          tag="li"
                        >{{items.title}}</router-link>
                      </ul>
                    </div>
                  </el-collapse-transition>
                </div>
              </div>
            </div>
            <div class="my_fl" style="padding-bottom:50px;width:960px;margin-left:20px;">
              <router-view></router-view>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="footer">
      <div class="soild"></div>
      <div class="soild1"></div>
      <div class="container">
        <el-row style="color: #999;margin-bottom: 30px" :gutter="60">
          <el-col :span="6">
            <div class="title">客户服务</div>
            <div class="info">
              <el-row :gutter="20">
                <el-col :span="12">
                  <!-- <a href="https://www.bioflin.com:83/qr_code.html" class="lv3Text" target="_blank">
                    <div class="box hvr-fade">
                      <div class="ico">
                        <i class="fas fa-chalkboard-teacher fa-lg"></i>
                      </div>
                      <div class="label">在线客服</div>
                    </div>
                  </a>-->
                  <div class="box hvr-fade">
                    <img width="86px" height="86px;" :src="serve + '/webInfo/official_wx.jpg'" alt />
                  </div>
                </el-col>
                <el-col :span="12">
                  <router-link to="/feedback">
                    <div class="box hvr-fade lv3Text">
                      <div class="ico">
                        <!-- <i class="fas fa-question-circle fa-lg"></i> -->
                        <i class="el-icon-question" style="font-size:34px"></i>
                      </div>
                      <div class="label">问题反馈</div>
                    </div>
                  </router-link>
                </el-col>
              </el-row>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="title">关注我们</div>
            <div class="info">
              <el-row>
                <el-col :span="12">
                  <el-popover placement="bottom-end" trigger="hover">
                    <div>
                      <img class="qr" :src="serve+src" style="width:150px;height:150px" />
                    </div>
                    <div slot="reference" class="box hvr-fade">
                      <img class="qr" :src="serve +src" style="width:88px;height:88px" />
                    </div>
                  </el-popover>
                </el-col>
                <el-col :span="12">
                  <a href="https://weibo.com/aogmayeli" target="_blank" class="lv3Text">
                    <div class="box hvr-fade">
                      <div class="ico">
                        <!-- <i class="fab fa-weibo fa-lg"></i> -->
                        <i class="iconfont icon-weibo" style="font-size:32px"></i>
                      </div>
                      <div class="label">微博</div>
                    </div>
                  </a>
                </el-col>
              </el-row>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="title">
              <router-link to="/brands" class="lv3Text brands">友情链接</router-link>
            </div>
            <div class="info">
              <span v-for="(item,index) of footer.data" :key="index">
                <a :href="item.link" target="_blank" rel="noopener noreferrer">
                  <el-link style="margin:3px 5px;">{{item.name}}</el-link>
                </a>
                <el-divider direction="vertical"></el-divider>
              </span>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="title">服务热线</div>
            <div class="phone">
              <span class="ico">
                <!-- <i class="fas fa-phone fa-lg fa-flip-horizontal"></i> -->
                <i class="el-icon-phone" style="font-size:34px"></i>
              </span>
              <span class="number">021-64179406</span>
            </div>
          </el-col>
        </el-row>
      </div>

      <div class="footer2" style="background-color: #EAEAEA;font-size: 12px;">
        <div class="container">
          <div class="top clearfix">
            <div class="first">
              <el-image
                class="img1"
                style="width: 146px; height: 46px"
                :src="serve + '/webInfo/1.png'"
                fit="cover"
              ></el-image>
            </div>
            <div class="label">
              <el-image
                class="img1"
                style="width: 146px; height: 46px"
                :src="serve + '/webInfo/2.png'"
                fit="cover"
              ></el-image>
            </div>
            <div class="label">
              <el-image
                class="img1"
                style="width: 146px; height: 46px"
                :src="serve + '/webInfo/3.png'"
                fit="cover"
              ></el-image>
            </div>
            <div class="end">
              <el-image
                class="img1"
                style="width: 146px; height: 46px"
                :src="serve + '/webInfo/4.png'"
                fit="cover"
              ></el-image>
            </div>
          </div>

          <div class="link1">
            <div class="list clearfix">
              <div>
                <ul>
                  <li>
                    <h3>新手入门</h3>
                  </li>
                  <li>
                    <a
                      href="http://www.bioflin.com/#/help/1_3"
                      target="_blank"
                      rel="noopener noreferrer"
                    >购物指南</a>
                  </li>
                  <li>
                    <a
                      href="http://www.bioflin.com/#/help/1_2"
                      target="_blank"
                      rel="noopener noreferrer"
                    >交易条款</a>
                  </li>
                  <li>
                    <a
                      href="http://www.bioflin.com/#/help/2_1"
                      target="_blank"
                      rel="noopener noreferrer"
                    >常见问题</a>
                  </li>
                  <li>
                    <a
                      href="http://www.bioflin.com/#/help/11"
                      target="_blank"
                      rel="noopener noreferrer"
                    >联系客服</a>
                  </li>
                </ul>
              </div>
              <div>
                <ul>
                  <li>
                    <h3>配送说明</h3>
                  </li>
                  <li>
                    <a
                      href="http://www.bioflin.com/#/help/3_2"
                      target="_blank"
                      rel="noopener noreferrer"
                    >上门自提</a>
                  </li>
                  <li>
                    <a
                      href="http://www.bioflin.com/#/help/3_2"
                      target="_blank"
                      rel="noopener noreferrer"
                    >一日达</a>
                  </li>
                  <li>
                    <a
                      href="http://www.bioflin.com/#/help/3_2"
                      target="_blank"
                      rel="noopener noreferrer"
                    >商品验收</a>
                  </li>
                  <li>
                    <a
                      href="http://www.bioflin.com/#/help/3_2"
                      target="_blank"
                      rel="noopener noreferrer"
                    >配送服务查询</a>
                  </li>
                </ul>
              </div>
              <div>
                <ul>
                  <li>
                    <h3>支付方式</h3>
                  </li>
                  <li>
                    <a
                      href="http://www.bioflin.com/#/help/4_2"
                      target="_blank"
                      rel="noopener noreferrer"
                    >账期支付</a>
                  </li>
                  <li>
                    <a
                      href="http://www.bioflin.com/#/help/4_3"
                      target="_blank"
                      rel="noopener noreferrer"
                    >在线支付</a>
                  </li>
                  <li>
                    <a
                      href="http://www.bioflin.com/#/help/4_4"
                      target="_blank"
                      rel="noopener noreferrer"
                    >公司转账</a>
                  </li>
                  <li>
                    <a
                      href="http://www.bioflin.com/#/help/5_1"
                      target="_blank"
                      rel="noopener noreferrer"
                    >发票制度</a>
                  </li>
                </ul>
              </div>
              <div>
                <ul>
                  <li>
                    <h3>售后服务</h3>
                  </li>
                  <li>
                    <a
                      href="http://www.bioflin.com/#/help/6_4"
                      target="_blank"
                      rel="noopener noreferrer"
                    >售后政策</a>
                  </li>
                  <li>
                    <a
                      href="http://www.bioflin.com/#/help/6_1"
                      target="_blank"
                      rel="noopener noreferrer"
                    >退款说明</a>
                  </li>
                  <li>
                    <a
                      href="http://www.bioflin.com/#/help/6_2"
                      target="_blank"
                      rel="noopener noreferrer"
                    >退换货政策</a>
                  </li>
                  <li>
                    <a
                      href="http://www.bioflin.com/#/help/6_3"
                      target="_blank"
                      rel="noopener noreferrer"
                    >退换货流程</a>
                  </li>
                </ul>
              </div>
              <div>
                <ul>
                  <li>
                    <h3>帮助中心</h3>
                  </li>
                  <li>
                    <a
                      href="http://www.bioflin.com/#/register"
                      target="_blank"
                      rel="noopener noreferrer"
                    >用户注册</a>
                  </li>
                  <li>
                    <a
                      href="http://www.bioflin.com/#/forget"
                      target="_blank"
                      rel="noopener noreferrer"
                    >找回密码</a>
                  </li>
                  <li>
                    <a
                      href="http://www.bioflin.com/#/help/9"
                      target="_blank"
                      rel="noopener noreferrer"
                    >公司介绍</a>
                  </li>
                  <li>
                    <a
                      href="http://www.bioflin.com/#/help/12"
                      target="_blank"
                      rel="noopener noreferrer"
                    >合作伙伴</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div
            align="center"
            style="padding-bottom: 10px;margin-top: 30px; color:#666666"
            class="footow"
          >
            <a
              href="http://www.bioflin.com/#/help/9"
              target="_blank"
              rel="noopener noreferrer"
              class="link"
            >公司简介</a> | &nbsp;
            <a
              href="http://www.bioflin.com/#/help/9"
              target="_blank"
              rel="noopener noreferrer"
              class="link"
            >关于我们</a> | &nbsp;
            <a
              href="http://www.bioflin.com/#/help/11"
              target="_blank"
              rel="noopener noreferrer"
              class="link"
            >联系我们</a> | &nbsp;
            <a href="https://www.bioflin.com:83/qr_code.html" class="link" target="_blank">联系客服</a>| &nbsp;
            <a href="https://www.bioflin.com/#/help" class="link" target="_blank">帮助中心</a>
            | &nbsp;
            <a
              href="https://www.bioflin.com/#/help/6_4"
              class="link"
              target="_blank"
            >售后服务</a>
            | &nbsp;
            <a
              href="https://www.bioflin.com/#/help/3_1"
              class="link"
              target="_blank"
            >配送与验收</a>| &nbsp;
            <a href="https://www.bioflin.com/#/help/10" class="link" target="_blank">隐私政策</a>
            | &nbsp;
            <a
              href="https://www.bioflin.com/#/join"
              class="link"
              target="_blank"
            >企业采购</a>
            | &nbsp;
            <a
              href="http://russian.chromatography-resin.com/"
              class="link"
              target="_blank"
            >PreventionProduct</a>
            | &nbsp;
            <a
              href="https://www.bioflin.com/#/results?topClass=%E8%AF%95%E5%89%82%2F%E7%94%9F%E5%8C%96%2F%E5%88%86%E5%AD%90%2F%E7%BB%86%E8%83%9E"
              class="link"
              target="_blank"
            >搜索推荐</a>
          </div>
          <div align="center" style="font-szie:12px;padding-bottom: 10px;">
            二类医疗器械证书号：沪徐食药监械经营备20200004号 ，
            互联网药品服务资格证书号：(沪)-经营性-2020-0018
          </div>
          <div align="center" style="font-szie:12px;color:#999999;padding-bottom: 10px;">
            Copyright &copy; 业立生物科技（上海）股份有限公司 丨 沪ICP备12011495号-3 丨
            <a
              target="_Blank"
              href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010402007073"
              style="color:#999999"
            >沪公网安备 31010402007073号</a>
          </div>
          <div class="alter clearfix">
            <a href="http://www.cyberpolice.cn/wfjb/ " target="_Blank">
              <div class="label">
                <el-image
                  style="width: 105px; height: 32px"
                  :src="serve + '/webInfo/police.png'"
                  fit="cover"
                ></el-image>
              </div>
            </a>
            <a href="http://www.12377.cn/" target="_Blank">
              <div class="label">
                <el-image
                  style="width: 105px; height: 32px"
                  :src="serve + '/webInfo/report.png'"
                  fit="cover"
                ></el-image>
              </div>
            </a>
            <a href="http://www.12377.cn/node_548446.htm " target="_Blank">
              <div class="label">
                <el-image
                  style="width: 105px; height: 32px"
                  :src="serve + '/webInfo/report_app.png'"
                  fit="cover"
                ></el-image>
              </div>
            </a>
            <a
              href="http://wap.scjgj.sh.gov.cn/businessCheck/verifKey.do?showType=extShow&serial=9031000020160818151512000001155629-SAIC_SHOW_310000-20171020200302788590&signData=MEUCIQC18ZuY5R7k6EKoSZONWIxq15nnRFY2U9GQhqlcSH5BkQIgTPPsVB23gtMlJL8zKAD7wzK74O87Ju7mDJBnuNlE9ms="
              target="_Blank"
            >
              <div class="label">
                <el-image
                  style="width: 105px; height: 32px"
                  :src="serve + '/webInfo/gs.png'"
                  fit="cover"
                ></el-image>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="right-menu" id="right-menu">
      <router-link to="/smartSearch">
        <div
          class="menu_seach"
          @mouseover="rightId=1"
          @mouseleave="rightId=0"
          :class="rightId == 1 ? 'menu_seach_left' :''"
        >
          <i
            class="iconfont icon-sousuo menu_seach_icon"
            :class="rightId == 1 ? 'active_color' :''"
            style="color:#E2211C"
          ></i>
          <div
            class="menu_seach_div"
            :class="rightId == 1 ? 'active_color' :''"
            style="color:#E2211C"
          >智能搜索</div>
        </div>
      </router-link>

      <router-link to="/user/cart">
        <div
          class="menu_shop"
          @mouseover="rightId=2"
          @mouseleave="rightId=0"
          :class="rightId == 2 ? 'menu_seach_left' :''"
        >
          <i
            class="iconfont icon-gouwuchekong menu_seach_icon"
            :class="rightId == 2 ? 'active_color' :''"
          ></i>
          <div class="menu_seach_div" :class="rightId == 2 ? 'active_color' :''">购物车</div>
        </div>
      </router-link>

      <a href="https://www.bioflin.com:83/qr_code.html" target="blank">
        <div
          class="menu_shop"
          @mouseover="rightId=3"
          @mouseleave="rightId=0"
          :class="rightId == 3 ? 'menu_seach_left' :''"
        >
          <i class="iconfont icon-zixun menu_seach_icon" :class="rightId == 3 ? 'active_color' :''"></i>
          <div class="menu_seach_div" :class="rightId == 3 ? 'active_color' :''">咨询</div>
        </div>
      </a>
      <router-link to="/feedback">
        <div
          class="menu_shop"
          @mouseover="rightId=4"
          @mouseleave="rightId=0"
          :class="rightId == 4 ? 'menu_seach_left' :''"
        >
          <i
            class="iconfont icon-fankui menu_seach_icon"
            :class="rightId == 4 ? 'active_color' :''"
          ></i>
          <div class="menu_seach_div" :class="rightId == 4 ? 'active_color' :''">反馈</div>
        </div>
      </router-link>

      <div
        class="menu_shop_top"
        @mouseover="rightId=5"
        @mouseleave="rightId=0"
        v-scroll-to="'#element'"
        @click="back()"
        :class="rightId == 5 ? 'menu_seach_left' :''"
      >
        <div style="height:5px"></div>
        <i
          class="iconfont icon-fankui icon-fanhuidingbu menu_seach_icon"
          :class="rightId == 5 ? 'active_color' :''"
        ></i>
        <div class="menu_seach_div" :class="rightId == 5 ? 'active_color' :''">回顶部</div>
      </div>
      <!-- <div class="item" @mouseover="rightId=1" @mouseleave="rightId=0">
        <router-link to="/user/home/0">
          <div class="icon" :class="rightId==1?'onHover':''">
          
          </div>
          <div v-if="rightId==1" class="text">个人中心</div>
        </router-link>
      </div>
      <div class="item" @mouseover="rightId=2" @mouseleave="rightId=0">
        <router-link to="/user/cart">
          <div class="icon1" :class="rightId==2?'onHover':''">
            
          </div>
          <div v-if="rightId==2" class="text">购物车</div>
        </router-link>
      </div>
      <div class="item" @mouseover="rightId=3" @mouseleave="rightId=0">
        <router-link to="/user/orders/1">
          <div class="icon2" :class="rightId==3?'onHover':''">
           
          </div>
          <div v-if="rightId==3" class="text">我的订单</div>
        </router-link>
      </div>
      <div class="item" @mouseover="rightId=4" @mouseleave="rightId=0">
        <router-link to="/user/history/1">
          <div class="icon3" :class="rightId==4?'onHover':''">
            
          </div>
          <div v-if="rightId==4" class="text">我的足迹</div>
        </router-link>
      </div>
      <div class="item" @mouseover="rightId=5" @mouseleave="rightId=0">
        <router-link to="/user/messages/0">
          <div class="icon4" :class="rightId==5?'onHover':''">
          </div>
          <div v-if="rightId==5" class="text">我的消息</div>
        </router-link>
      </div>
      <div class="item" @mouseover="rightId=6" @mouseleave="rightId=0">
        <a href="https://www.bioflin.com:83/qr_code.html" target="blank">
          <div class="icon5" :class="rightId==6?'onHover':''">
          </div>
          <div v-if="rightId==6" class="text">在线客服</div>
        </a>
      </div>
      <div
        class="item"
        @mouseover="rightId=7"
        v-scroll-to="'#element'"
        @mouseleave="rightId=0"
        @click="back()"
      >
        <div class="icon6" :class="rightId==7?'onHover':''"></div>
        <div v-if="rightId==7" class="text">返回顶部</div>
      </div>-->
    </div>
  </div>
</template>

<script>
import bioTopBar from "../../components/bioTopBar.vue";
export default {
  components: { bioTopBar },
  data() {
    return {
      serve: this.$store.state.serve,

      isleftList: 0,
      isLi: null,
      nav: [
        {
          title: "我的账户",
          arr: [
            {
              title: "个人中心",
              path: "/user/home"
            },
            {
              title: "消息通知",
              path: "/user/messages"
            },
            {
              title: "个人信息",
              path: "/user/userInfo"
            },
            {
              title: "安全设置",
              path: "/user/safety"
            },
            {
              title: "地址管理",
              path: "/user/address"
            },
            {
              title: "邀请有礼",
              path: "/user/invit"
            }
          ]
        },
        {
          title: "我的商城",
          arr: [
            {
              title: "我的订单",
              path: "/user/orders"
            },
            {
              title: "优惠券",
              path: "/user/coupons"
            },
            {
              title: "收藏的商品",
              path: "/user/collections"
            },
            {
              title: "我的积分",
              path: "/user/score"
            },
            {
              title: "我的足迹",
              path: "/user/history"
            },
            {
              title: "收藏的品牌",
              path: "/user/brand"
            }
          ]
        },
        {
          title: "会员开通",
          arr: [
            {
              title: "预付款",
              path: "/user/bargain"
            }
          ]
        },
        {
          title: "子/主账户管理",
          arr: [
            {
              title: "子/主账户管理",
              path: "/user/children"
            },
            {
              title: "订单管理",
              path: "/user/childrenOrder"
            }
          ]
        },
        {
          title: "经费管理",
          arr: [
            {
              title: "经费管理",
              path: "/user/expenditure/1"
            }
          ]
        },
        {
          title: "实验室管理",
          arr: [
            {
              title: "库存管理",
              path: "/user/state/1"
            },
            {
              title: "实验室规章制度",
              path: "/user/policy/1"
            }
          ]
        },
        {
          title: "危险品管理",
          arr: [
            {
              title: "危险品管理",
              path: "/user/riskManage/1"
            },
            {
              title: "政策法规",
              path: "/user/policy/2"
            }
          ]
        },
        // {
        //   title: "发布信息",
        //   arr: [
        //     {
        //       title: "资源共享",
        //       path: "/user/login_share"
        //     },
        //     {
        //       title: "专利发布",
        //       path: "/user/createPatent"
        //     }
        //   ]
        // },
        {
          title: "BioflinNews",
          arr: [
            {
              title: "BioflinNews",
              path: "/user/myNews/1"
            }
          ]
        },
        {
          title: "帮助中心",
          arr: [
            {
              title: "帮助中心",
              path: "/help"
            },
            {
              title: "售后服务",
              path: "/user/after"
            }
          ]
        }
      ],
      rightId: 0,
      src: "",
      words: "",
      carts: [],
      total: 0,
      keywords: "",
      index: null,
      footer: "",
      fullPath: "",
      i: 0
    };
  },
  updated() {
    // console.log(this.$store.state.login_left + 'updata');
  },
  activated() {
    // console.log(this.$store.state.login_left + 'active');
  },
  beforeCreate() {
    this.isleftList = this.$store.state.login_left;
  },
  created() {
    // console.log(this.$store.state.login_left + 'create');
    // this.isleftList = this.$store.state.login_left;
    this.router(this.$route);
    this.index = this.$store.state.leftMenuIndex;
    this.axios.get(this.serve + "/get_foot_brand").then(res => {
      this.footer = res.data;
    });

    this.axios.get(this.serve + "/wxgzh_img").then(res => {
      this.src = res.data.data;
    });
  },
  methods: {
    back() {
      //设置scrollTop
      var scrollTop =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        document.body.scrollTop;
      const _this = this;
      var time = setInterval(function() {
        scrollTop /= 6;
        if (scrollTop < 100) {
          scrollTop = 0;
          clearInterval(time);
        }
        _this.setScrollTop(scrollTop);
      }, 16.7);
    },
    setScrollTop(top) {
      document.documentElement.scrollTop = top;
      window.pageYOffset = top;
      document.body.scrollTop = top;
    },
    //左导航
    changeTitle(v, w) {
      this.isleftList = v;
      if (w == true) {
        this.isleftList = null;
      }
    },
    //
    router(v) {
      this.isLi = v.path;
      this.isleftList = v.params.path;
      this.fullPath = v.fullPath.split("/")[2];
      if (this.fullPath == "home") {
        this.i = 1;
      } else if (this.fullPath == "messages") {
        this.i = 2;
      } else if (this.fullPath == "userInfo") {
        this.i = 3;
      } else if (this.fullPath == "safety") {
        this.i = 4;
      } else if (this.fullPath == "address") {
        this.i = 5;
      } else if (this.fullPath == "score") {
        this.i = 6;
      } else if (this.fullPath == "history") {
        this.i = 7;
      } else if (this.fullPath == "invit") {
        this.i = 8;
      } else if (this.fullPath == "children") {
        this.i = 9;
      } else if (this.fullPath == "expenditure" || this.fullPath == "viewEx") {
        this.i = 10;
      } else if (this.fullPath == "state" || this.fullPath == "viewState") {
        this.i = 11;
      } else if (
        this.fullPath &&
        (this.fullPath == "orders" || this.fullPath.search("viewOrder") != -1)
      ) {
        this.i = 12;
      } else if (this.fullPath == "coupons") {
        this.i = 13;
      } else if (this.fullPath == "idle") {
        this.i = 14;
      } else if (this.fullPath == "after") {
        this.i = 15;
      } else if (
        this.fullPath &&
        (this.fullPath == "collections" || this.fullPath.search("like") != -1)
      ) {
        this.i = 16;
      } else if (this.fullPath == "myNews") {
        this.i = 17;
      } else if (this.fullPath == "brand") {
        this.i = 18;
      } else if (this.fullPath == "help") {
        this.i = 19;
      } else {
        this.i = 0;
      }
    }
  },
  watch: {
    "$store.state.leftMenuIndex": {
      handler: function(newer, older) {
        this.index = newer;
      }
    },
    // "$store.state.login_left": {
    //   handler: function(n, o) {
    //     console.log(n);
    //     this.isleftList = n;
    //   }
    // },

    $route: "router"
  }
};
</script>
<style lang="scss">
.clearfix:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.tel {
  line-height: 30px;
  margin-left: 10px;
}
.t1 {
  color: #666;
  svg {
    margin-right: 5px;
  }
}
body {
  font-size: 14px;
  font-family: "微软雅黑";
}

ul,
li {
  padding: 0;
  margin: 0;
  list-style: none;
}
#userTpl {
  .my_fl {
    float: left;
  }
  .box_left {
    width: 220px;
    background: #ddd;
    .box_list {
      // margin-bottom: 1px;
      border-bottom: 1px solid #fff;
    }
    .box_title {
      position: relative;
      height: 40px;
      // width: 216px;
      max-width: 216px;
      background: #ddd;
      text-align: left;
      padding-left: 50px;
      line-height: 40px;
      cursor: pointer;
      font-size: 14px;
      font-family: "MicrosoftYaHei";
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      .box_icon {
        position: absolute;
        right: 8px;
        top: 0;
        color: #666666;
        transition: 0.5s;
        // margin-top: -7px;
      }
      .box_icon1 {
        color: #e2211c;
        transform: rotate(-180deg);
        transition: 0.5s;
      }
    }

    .box_border {
      position: absolute;
      left: 0;
      top: 0;
      width: 4px;
      height: 100%;
      background: rgba(226, 33, 28, 1);
    }
    .box_show {
      li {
        height: 40px;
        background: rgba(255, 255, 255, 1);
        // width: 100%;
        max-width: 100%;
        margin-bottom: 1px;
        font-size: 14px;
        font-family: "MicrosoftYaHei";
        font-weight: bold;
        // color: rgba(226, 33, 28, 1);
        color: #333333;
        text-align: left;
        padding-left: 50px;
        line-height: 40px;
        cursor: pointer;
      }
      li:hover {
        color: #e2211c;
      }
      .boxli {
        color: #e2211c;
      }
    }
  }
  .onHover {
    background-color: #e2211c;
    color: #fff;
  }
  @media (max-width: 1720px) {
    #right-menu {
      background: #f5f5f5;
      position: fixed;
      bottom: 100px;
      right: 0;
    }
  }
  .right-menu {
    z-index: 99;
    position: fixed;
    margin-left: 1660px;
    bottom: 100px;
    .menu_seach_left {
      background: #e2211c !important ;
    }
    .active_color {
      color: #fff !important;
    }
    .menu_seach {
      width: 54px;
      height: 74px;
      background: #f5f5f5;
      border: 1px solid rgba(221, 221, 221, 1);
      border-radius: 2px;
      text-align: center;
      font-size: 14px;
      margin-bottom: 20px;
      cursor: pointer;
      position: relative;

      .menu_seach_icon {
        font-size: 22px;
        line-height: 36px;
        color: #999999;
      }
      .menu_seach_div {
        color: #333333;
        line-height: 18px;
        font-size: 12px;
        width: 28px;
        margin: 0 auto;
      }
    }
    .menu_shop {
      cursor: pointer;
      width: 54px;
      height: 58px;
      background: rgba(245, 245, 245, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      border-radius: 2px;
      text-align: center;
      position: relative;
      .menu_shop_left {
        width: 54px;
        background: #e2211c;
        height: 58px;
        border-radius: 2px;
        text-align: center;
        position: absolute;
        top: 0;
        left: -70px;
      }
      .menu_seach_icon {
        font-size: 22px;
        line-height: 36px;
        color: #999999;
      }
      .menu_seach_div {
        color: #333333;
        line-height: 18px;
        font-size: 12px;
      }
    }
    .menu_shop_top {
      cursor: pointer;
      width: 54px;
      height: 58px;
      background: #e8e8e8;
      border: 1px solid rgba(221, 221, 221, 1);
      border-radius: 2px;
      text-align: center;
      margin-top: 20px;
      position: relative;
      .menu_shop_left {
        width: 54px;
        background: #e2211c;
        height: 58px;
        border-radius: 2px;
        text-align: center;
        position: absolute;
        top: 0;
        left: -70px;
      }
      .menu_seach_icon {
        font-size: 26px;
        color: #999999;
      }
      .menu_seach_div {
        color: #333333;
        line-height: 18px;
        font-size: 12px;
      }
    }
    // .item {
    //   .icon {
    //     height: 44px;
    //     width: 44px;
    //     background-image: url(../../assets/images/leftLogo.png);
    //     background-position: 0px 0px;
    //   }
    //   .icon:hover {
    //     height: 44px;
    //     width: 44px;
    //     background-image: url(../../assets/images/rightLogo.png);
    //     background-position: 0px 0px;
    //   }
    //   .icon1 {
    //     height: 44px;
    //     width: 44px;
    //     background-image: url(../../assets/images/leftLogo.png);
    //     background-position: 0px -39px;
    //   }
    //   .icon1:hover {
    //     height: 44px;
    //     width: 44px;
    //     background-image: url(../../assets/images/rightLogo.png);
    //     background-position: 0px -39px;
    //   }
    //   .icon2 {
    //     height: 44px;
    //     width: 44px;
    //     background-image: url(../../assets/images/leftLogo.png);
    //     background-position: 0px -77px;
    //   }
    //   .icon2:hover {
    //     height: 44px;
    //     width: 44px;
    //     background-image: url(../../assets/images/rightLogo.png);
    //     background-position: 0px -77px;
    //   }
    //   .icon3 {
    //     height: 44px;
    //     width: 44px;
    //     background-image: url(../../assets/images/leftLogo.png);
    //     background-position: 0px -116px;
    //   }
    //   .icon3:hover {
    //     height: 44px;
    //     width: 44px;
    //     background-image: url(../../assets/images/rightLogo.png);
    //     background-position: 0px -116px;
    //   }
    //   .icon4 {
    //     height: 44px;
    //     width: 44px;
    //     background-image: url(../../assets/images/leftLogo.png);
    //     background-position: 0px -155px;
    //   }
    //   .icon4:hover {
    //     height: 44px;
    //     width: 44px;
    //     background-image: url(../../assets/images/rightLogo.png);
    //     background-position: 0px -155px;
    //   }
    //   .icon5 {
    //     height: 44px;
    //     width: 44px;
    //     background-image: url(../../assets/images/leftLogo.png);
    //     background-position: 0px 79px;
    //   }
    //   .icon5:hover {
    //     height: 44px;
    //     width: 44px;
    //     background-image: url(../../assets/images/rightLogo.png);
    //     background-position: 0px 79px;
    //   }
    //   .icon6 {
    //     height: 44px;
    //     width: 44px;
    //     background-image: url(../../assets/images/leftLogo.png);
    //     background-position: 0px 39px;
    //   }
    //   .icon6:hover {
    //     height: 44px;
    //     width: 44px;
    //     background-image: url(../../assets/images/rightLogo.png);
    //     background-position: 0px 39px;
    //   }
    //   svg {
    //     color: #c0c4cc;
    //     height: 44px;
    //   }
    //   .onHover {
    //     svg {
    //       color: #fff;
    //     }
    //   }
    //   height: 44px;
    //   width: 44px;
    //   background-color: #fff;
    //   margin-bottom: 2px;
    //   cursor: pointer;
    //   text-align: center;
    // }
    // .text {
    //   background-color: #e2211c;
    //   color: #fff;
    //   text-align: center;
    //   height: 44px;
    //   line-height: 44px;
    //   padding: 0 5px;
    //   position: relative;
    //   left: -80px;
    //   width: 70px;
    //   top: -44px;
    // }
  }
  .leftMenu {
    padding: 30px 0;
    background-color: #fff;
    border: 1px solid #ddd;
    .title {
      font-size: 20px;
      color: #999;
      padding-left: 39px;
      line-height: 50px;
    }
    .item {
      height: 45px;
      width: 179px;
      line-height: 45px;
      padding-left: 39px;
      border-left: 4px solid #fff;

      color: #333;
    }

    .item.active {
      color: #e2211c;
      border-color: #e2211c;
    }
    .item:hover {
      color: #e2211c;
    }
  }
  .img1 {
    position: relative;
    top: 20px;
    margin-right: 10px;
  }
  .el-menu-item:hover,
  .el-menu-item.active,
  .el-menu-item.is-active {
    border-left: 3px solid #e2211c;
    background-color: #feedef;
  }

  .el-menu-item {
    border-left: 3px solid #fff;
    height: 45px;
    line-height: 45px;
  }
  #footer {
    padding: 60px 0 0 0;
    .footow > a:hover {
      color: #e2211c;
    }
    .title {
      text-align: center;
      font-size: 19px;
      color: #999;
      margin-bottom: 20px;
    }

    .info {
      text-align: center;
      .brand {
        text-decoration: none;
        color: #999;
      }
      .brand:hover {
        color: #e2211c;
      }
      .brand.hvr-fade {
        display: inline;
      }
    }
    .phone {
      text-align: center;
      .ico {
        font-size: 20px;
        margin-right: 20px;
      }
      .number {
        font-size: 17px;
        font-weight: bold;
      }
    }
    .box {
      border: 1px solid #e8e8e8;
      height: 86px;
      width: 86px;
      margin: 0 auto;
      .ico {
        text-align: center;
        padding: 20px 0 10px 0;
        font-size: 25px;
      }
      .label {
        text-align: center;
        font-size: 13px;
      }
    }
    .box:hover {
      color: #e2211c;
      border: 1px solid #e2211c;
      cursor: pointer;
    }
    .hvr-fade {
      background-color: transparent;
    }
    .footer2 {
      .top {
        padding: 10px 0;
        line-height: 80px;
        // display: flex;
        // justify-content: space-between;
        > div {
          float: left;
          margin-right: 70px;
          padding-left: 70px;
        }
      }
      .link1 {
        .list {
          color: #333333;
          // display: flex;
          // justify-content: space-between;
          > div {
            float: left;
            padding-left: 90px;
            margin-right: 80px;
          }
          ul {
            padding: 0;
          }
          li {
            line-height: 30px;
            list-style: none;
            text-align: left;
          }
          li > a:hover {
            color: #e2211c;
          }
        }
      }
      // .alter {
      //   display: flex;
      //   justify-content: center;
      //   padding-bottom: 20px;
      // }
    }
  }
  #footer {
    position: relative;
    .soild {
      width: 100%;
      height: 1px;
      background: rgba(221, 221, 221, 1);
      position: absolute;
      top: 346px;
      left: 0;
    }
    .soild1 {
      width: 100%;
      height: 1px;
      background: rgba(221, 221, 221, 1);
      position: absolute;
      left: 0;
      bottom: 130px;
    }
    padding: 30px 0 0 0;
    .footow > a:hover {
      color: #e2211c;
    }
    .title {
      text-align: center;
      font-size: 19px;
      color: #999;
      margin-bottom: 20px;
    }

    .info {
      text-align: center;
      .brand {
        text-decoration: none;
        color: #999;
      }
      .brand:hover {
        color: #e2211c;
      }
      .brand.hvr-fade {
        display: inline;
      }
    }
    .phone {
      text-align: center;
      .ico {
        color: ccc;
        font-size: 20px;
        margin-right: 20px;
      }
      .number {
        font-size: 17px;
        font-weight: bold;
      }
    }
    .box {
      border: 1px solid #e8e8e8;
      height: 86px;
      width: 86px;
      margin: 0 auto;
      .ico {
        text-align: center;
        padding: 20px 0 10px 0;
        font-size: 25px;
      }
      .label {
        text-align: center;
        font-size: 12px;
      }
    }
    .box:hover {
      color: #e2211c;
      border: 1px solid #e2211c;
      cursor: pointer;
    }
    .hvr-fade {
      background-color: transparent;
    }
    .footer2 {
      .top {
        padding: 10px 0;

        line-height: 80px;
        display: flex;
        justify-content: space-between;
      }
      .link1 {
        .list {
          color: #333333;
          display: flex;
          justify-content: space-between;
          h3 {
            font-size: 16px;
            font-family: "MicrosoftYaHei";
            font-weight: 400;
            color: rgba(102, 102, 102, 1);
          }
          ul {
            padding: 0;
          }
          li {
            line-height: 30px;
            list-style: none;
            text-align: left;
          }
          li > a:hover {
            color: #e2211c;
          }
        }
      }
      .alter {
        width: 500px;
        margin: 0 auto;
        padding-bottom: 20px;
        > a {
          // display: inline-block;
          // *display: inline;
          // *zoom: 1;
          float: left;
        }
      }
    }
  }
}
</style>